import { SchematicAPI } from "../actions/schematicAPI";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
const { ActionTypes } = Constants;

export const TabActions = {
  closeVoidedModal: function () {
    dispatcher.dispatch({
      type: ActionTypes.VOIDED_MODAL_CLOSE,
    });
  },
  changeTab: function (tabIndex, tabChanged) {
    dispatcher.dispatch({
      type: ActionTypes.TAB_CHANGED,
      tabIndex: tabIndex,
      tabChanged: tabChanged,
    });
    //For now we are showing alt track names for A and B. Leaving this code incase there is another type that need the primary track names
    // if (tabChanged == "form") { //Only changes to the form type tab affect track names
    //     if (tabIndex == 1)
    //         SchematicAPI.useAlternateTrackName(true); //show alt track names
    //     else if (tabIndex == 2)
    //         SchematicAPI.useAlternateTrackName(false); //show primary track names
    // }

    SchematicAPI.resetSchematicNoPrompt();

    //Reset the form whenever a tab is changed
    dispatcher.dispatch({
      type: ActionTypes.RESET_FORM_B_RESTRICTION,
    });
  },
  backgroundReload: function (tabIndex, tabChanged) {
    dispatcher.dispatch({
      type: ActionTypes.BACKGROUND_RELOAD,
      tabIndex: tabIndex,
      tabChanged: tabChanged,
    });
  },

  switchToPreviousTab: function () {
    dispatcher.dispatch({
      type: ActionTypes.GO_TO_PREVIOUS_TAB,
    });
  },

  batchSelect: function (requestId) {
    dispatcher.dispatch({
      type: ActionTypes.BATCH_SELECT,
      requestId: requestId,
    });
  },

  setBatchMode: function (batchMode) {
    dispatcher.dispatch({
      type: ActionTypes.CHANGE_BATCH_MODE,
      batchMode: batchMode,
    });
  },

  setCurrentBatch: function (newBatchIndex) {
    dispatcher.dispatch({
      type: ActionTypes.NEW_BATCH_INDEX,
      batchIndex: newBatchIndex,
    });
  },

  selectBatchType: function (type) {
    dispatcher.dispatch({
      type: ActionTypes.SELECT_BATCH_TYPE,
      batchType: type,
    });
  },

  startBatch: function (batchType, list) {
    dispatcher.dispatch({
      type: ActionTypes.START_BATCH,
    });
  },

  toggleCollapse: function (setToCollapseState) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_COLLAPSE,
      newState: setToCollapseState,
    });
    SchematicAPI.toggleSchematicCollapse(setToCollapseState);
  },

  recentSortChanged: function (sortBy, sortDirection) {
    dispatcher.dispatch({
      type: ActionTypes.RECENT_LIST_SORT_CHANGED,
      sortBy: sortBy,
      sortDirection: sortDirection,
    });
  },

  centerZoomCheckChanged: function (checked) {
    dispatcher.dispatch({
      type: ActionTypes.CENTER_ZOOM_CHANGED,
      checked: checked,
    });
  },
};
